import React, { useMemo } from 'react';
import classnames from 'classnames';
import LocationCoordinateTableCell from '../../shared/LocationCoordinateTableCell';
import ClocksTableCell from '../../shared/ClocksTableCell';
import '../../shared/TimecardsTable.css';

const Row = ({
  employeeId,
  name,
  timecards,
  onRowSelect,
  ...props
}) => {
  const isClockedIn = useMemo(() => timecards.some(timecard => timecard.start !== null && timecard.end === null), [timecards]);

  const indicatorClassNames = classnames({
    'timecards-table-clock-indicator': true,
    'timecards-table-clock-indicator-in': isClockedIn,
    'timecards-table-clock-indicator-out': !isClockedIn
  });

  return (
    <tr
      className='timecards-table-row timecards-table-employee-row'
      onClick={() => onRowSelect({ employeeId, name })}
    >
      <td className='flex-rows' style={{ alignItems: 'center' }}>
        <div className={indicatorClassNames} />
        <span className='timecards-table-employee-row-text'>{name}</span>
      </td>
      <ClocksTableCell
        timecards={timecards}
        direction='in'
      />
      <LocationCoordinateTableCell
        timecards={timecards}
        direction='in'
      />
      <ClocksTableCell
        timecards={timecards}
        direction='out'
      />
      <LocationCoordinateTableCell
        timecards={timecards}
        direction='out'
      />
    </tr>
  );
};

export default Row;
